// Query-layer types
type LookupByEmailRequest = { email: string };
type LookupByUserIdRequest = { userId: string };
export type LookupRequest = LookupByEmailRequest | LookupByUserIdRequest;
export type LookupResponse = {
  itblUserId?: string;
  email?: string;
};

// Form-layer types
export enum LookupType {
  ByEmail,
  ByUserId,
}
export enum FormGridAreas {
  lookupTypeRadioList = 'lookupTypeRadioList',
  identifierInput = 'identifierInput',
  submitButton = 'submitButton',
}
export type FormState = {
  identifier: string;
  lookupType: LookupType;
};
